"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpinnerStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../../style/commons/_colors");
exports.useSpinnerStyles = (0, core_1.makeStyles)(function () { return ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 104,
        flexDirection: 'column',
        backgroundColor: _colors_1.white,
    },
    loader: {
        marginTop: 8,
        marginBottom: 16,
        color: _colors_1.mediumGreen,
    },
    title: {
        marginTop: 0,
        marginBottom: 8,
    },
}); });
